import React from "react";
import LocationsUsed from "../LocationsUsed/LocationsUsed";

export default class SearchDrawer extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps, prevState) {
    var self = this;
  }

  render() {
    var course_collection = this.getCourseCollection();

    return (
      <div className={"search-drawer " + (this.props.open ? "open" : "")}>
        <div className="search-drawer-header">
          <h2>Article Preview</h2>
          <div
            className="search-drawer-close"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.keyCode === 13) {
                this.props.onToggleDrawer();
              }
            }}
            onClick={this.props.onToggleDrawer}
          >
            ×
          </div>
        </div>
        <div className="search-drawer-name">
          <div className="preview-image">
            <img
              src={this.props.image_preview_path}
              alt={`Image of ${this.props.name}`}
            />
          </div>
          <div className="value">
            <h3>{this.props.name}</h3>
            <h4>{this.props.course_collections[0].name}</h4>
          </div>
          <div className="actions">
            <a href={this.props.path} className="action-button primary">
              OPEN
            </a>
          </div>
        </div>
        <LocationsUsed course_collection={course_collection} />
      </div>
    );
  }

  /**
   * Helper function
   */

  getCourseCollection() {
    if (this.props.course_collections && this.props.course_collections.length) {
      var course_collection = this.props.course_collections[0];
      for (
        var i = 0, ilen = this.props.account_course_collections.length;
        i < ilen;
        i++
      ) {
        var acc = this.props.account_course_collections[i];
        if (acc && acc["id"] == course_collection["id"]) {
          course_collection["courses"] = acc["courses"];
          return course_collection;
        }
      }
    }
    return null;
  }
}
